import listOl from '../../icons/list-ol.svg'

export default {
  name: 'ordered-list',
  title: '有序列表',
  icon: listOl,
  handler (editor) {
    editor.execCommand('insertOrderedList')
  }
}
